
export const ALLOWED_KEYS = [
  'Shift', 'ShiftLeft', 'ShiftRight',
  'CapsLock',
  'Control', 'ControlLeft', 'ControlRight',
  'Alt', 'AltLeft', 'AltRight',
  'Meta', 'MetaLeft', 'MetaRight',
  'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight',
  'Backspace',
  'Delete',
  'Tab',
  "=","-", "+", "/","$",
  " ", "space",
];